import { render, staticRenderFns } from "./LabourService.vue?vue&type=template&id=1880cb22&scoped=true&"
import script from "./LabourService.vue?vue&type=script&lang=js&"
export * from "./LabourService.vue?vue&type=script&lang=js&"
import style0 from "./LabourService.vue?vue&type=style&index=0&id=1880cb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1880cb22",
  null
  
)

export default component.exports